import PropTypes from 'prop-types'
import React from 'react'

const AboutContentProfileCard = ({ aboutText }) => {
    return (
        <div className="mb-4 p-4 shadow-sm rounded-4 bg-white">
            <h5 className="fw-bold mb-3">About</h5>
            {aboutText ? (
                aboutText?.length !== 0 ? (
                    <p className="text-muted mb-0">
                        {aboutText}
                    </p>
                ) : (
                    <p className="text-muted mb-0">No about description added</p>
                )
            ) : (
                <p className="text-muted mb-0">No about description added</p>
            )}
        </div>
    )
}
export default AboutContentProfileCard
AboutContentProfileCard.propTypes = {
    aboutText: PropTypes.string,
}
